import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { scorerJoinLeague } from 'src/app/store/actions/tournament.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-assign-scorer',
  templateUrl: './assign-scorer.component.html',
  styleUrls: ['./assign-scorer.component.scss']
})
export class AssignScorerComponent implements OnInit {

  scorers!: any;
  league!: any;
  seasonId!: any;

  form: FormGroup

  constructor(
    private modalService: ModalService,
    private store: Store<AppState>,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      scorerId: ['', [Validators.required]]
    })
    console.log(this.seasonId);
  }

  close(){
    this.modalService.hideAssignScorers();
  }

  confirm(){
    this.modalService.showLoadingSpinner();
    this.store.dispatch(scorerJoinLeague({league: this.league, scorerId: this.scorerId?.value, seasonId: this.seasonId}))
  }

  get scorerId(){
    return this.form.get('scorerId')
  }

}
